var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDealsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.75C0 1.23122 1.23122 0 2.75 0H13.25C14.7688 0 16 1.23122 16 2.75V13.25C16 14.7688 14.7688 16 13.25 16H2.75C1.23122 16 0 14.7688 0 13.25V2.75ZM2.75 1.5C2.05964 1.5 1.5 2.05964 1.5 2.75V13.25C1.5 13.9404 2.05964 14.5 2.75 14.5H13.25C13.9404 14.5 14.5 13.9404 14.5 13.25V2.75C14.5 2.05964 13.9404 1.5 13.25 1.5H2.75ZM4.75 5C5.16421 5 5.5 5.33579 5.5 5.75V11.25C5.5 11.6642 5.16421 12 4.75 12C4.33579 12 4 11.6642 4 11.25V5.75C4 5.33579 4.33579 5 4.75 5ZM11.25 5C11.6642 5 12 5.33579 12 5.75V11.25C12 11.6642 11.6642 12 11.25 12C10.8358 12 10.5 11.6642 10.5 11.25V5.75C10.5 5.33579 10.8358 5 11.25 5ZM8 8C8.41421 8 8.75 8.33579 8.75 8.75V11.25C8.75 11.6642 8.41421 12 8 12C7.58579 12 7.25 11.6642 7.25 11.25V8.75C7.25 8.33579 7.58579 8 8 8Z",
    fill: "#9E9FA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealsIcon);
export default __webpack_public_path__ + "static/media/dealsIcon.3e79b6bfec7982568ad8f4d539be6cac.svg";
export { ForwardRef as ReactComponent };